import React, { useEffect, useState } from "react";
import logo from '../images/tech4mation logo-02 1.svg';
import { Link, useLocation } from "react-router-dom";

const Header = () =>{
    const location = useLocation();
    const [activeLink, setActiveLink] = useState(location.pathname);
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        // Update the active link when the path changes
        setActiveLink(location.pathname);
    }, [location]);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    return(
        <div className='header'>
            <Link to="/"><img src={logo} alt="" /></Link>

            <nav>
                <div className="hamburger" onClick={toggleMobileMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
                
                <ul className={isMobileMenuOpen ? "mobile-menu-open" : ""}>
                    <li>
                        <Link to="/"className={activeLink === "/" ? "active-link" : ""}>
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link to="/about" className={activeLink === "/about" ? "active-link" : ""}>
                            about us
                        </Link>
                    </li>
                    <li>
                        <Link to="/service" className={activeLink === "/service" ? "active-link" : ""}>
                            OUR SERVICES
                        </Link>
                    </li>
                    {/* <li>
                        <Link to="/lead" className={activeLink === "/lead" ? "active-link" : ""}>
                            OUR LEADERSHIP
                        </Link>
                    </li> */}
                    <li>
                        <Link to="/contact" className={activeLink === "/contact" ? "active-link" : ""}>
                            CONTACT US
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Header;